import { Translation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ConfigSVG from '@/assets/icons/config.svg';
import LogoutSVG from '@/assets/icons/logout.svg';

export const MobileNavBarItems = ({
  onManual,
  onLogout,
  onSettings,
}: {
  onManual: () => void;
  onLogout: () => void;
  onSettings: () => void;
}) => {
  return (
    <nav className="lg:hidden">
      <ul className="flex flex-col text-base font-medium">
        {navItems.map(({ key, element }) => (
          <li className="p-4" key={key}>
            {element}
          </li>
        ))}
        <li className="p-4">
          <Translation>
            {(t) => <button onClick={onManual}>{t('header.manual')}</button>}
          </Translation>
        </li>
        <li className="p-4">
          <Translation>{(t) => <Link to="/debug">{t('header.debug')}</Link>}</Translation>
        </li>
        <li className="border-t">
          <button onClick={onSettings} className="flex items-center w-full gap-2 p-4">
            <img src={ConfigSVG} alt="config" />
            <Translation>{(t) => <>{t('header.settings')}</>}</Translation>
          </button>
        </li>
        <li>
          <button onClick={onLogout} className="flex items-center w-full gap-2 p-4">
            <img src={LogoutSVG} alt="logout" />
            <Translation>{(t) => <>{t('header.logout')}</>}</Translation>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export const DesktopNavBarItems = ({
  onManual,
  onSettings,
}: {
  onManual: () => void;
  onSettings: () => void;
}) => {
  return (
    <nav className="hidden lg:block">
      <ul className="flex gap-12 text-base font-medium">
        {navItems.map(({ key, element }) => (
          <li key={key}>{element}</li>
        ))}
        <li>
          <Translation>
            {(t) => (
              <button onClick={onManual} id="step-manual">
                {t('header.manual')}
              </button>
            )}
          </Translation>
        </li>
        <li>
          <Translation>
            {(t) => <button onClick={onSettings}>{t('header.settings')}</button>}
          </Translation>
        </li>
        <li>
          <Translation>{(t) => <Link to="/debug">{t('header.debug')}</Link>}</Translation>
        </li>
      </ul>
    </nav>
  );
};

const navItems = [
  {
    key: 'Dashboard',
    element: (
      <Translation>
        {(t) => (
          <Link to="/" id="step-dashboard">
            {t('header.dashboard')}
          </Link>
        )}
      </Translation>
    ),
  },
  {
    key: 'Support',
    element: (
      <Translation>
        {(t) => (
          <a href="mailto:support@oculyze.net?subject=&body=" id="step-support">
            {t('header.support')}
          </a>
        )}
      </Translation>
    ),
  },
  {
    key: 'Shop',
    element: (
      <Translation>
        {(t) => (
          <a
            href="https://www.oculyze.net/consumables/"
            id="step-shop"
            target="_blank"
            rel="noreferrer"
          >
            {t('header.order')}
          </a>
        )}
      </Translation>
    ),
  },
];
